module.exports = __webpack_public_path__ + "img/retrospect-1.0d0c4c8a.jpg";